import type { SupplierStatementParty, SupplierStatementReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { StatementPartyRef } from './customer-statement-api';

/** Under `['reports', ...]` so anything invalidating `reportKeys.all` refreshes these too. */
export const supplierStatementKeys = {
  suppliers: (branchId: string, search: string) => ['reports', 'supplier-statement', 'suppliers', branchId, search] as const,
  statement: (party: StatementPartyRef | null, from: string, to: string) =>
    ['reports', 'supplier-statement', party?.deviceId, party?.sourceId, from, to] as const,
};

export function fetchStatementSuppliers(
  branchId: string,
  search: string,
  signal?: AbortSignal,
): Promise<SupplierStatementParty[]> {
  return portalApi.get<SupplierStatementParty[]>(
    `/portal/reports/supplier-statement/suppliers${queryString({ branchId, search })}`,
    { signal },
  );
}

export function fetchSupplierStatement(
  party: StatementPartyRef,
  range: { from: string; to: string },
  signal?: AbortSignal,
): Promise<SupplierStatementReport> {
  return portalApi.get<SupplierStatementReport>(
    `/portal/reports/supplier-statement${queryString({ deviceId: party.deviceId, sourceId: party.sourceId, from: range.from, to: range.to })}`,
    { signal },
  );
}
